import request from '@/utils/request'

// 获取详情页
export function getProductDetail(id) {
  return request({
    url: `/exhibition/product/${id}`,
    method: 'get',
    params: {},
  })
}

// 获取详情页可选属性
export function getOptional(data) {
  return request({
    url: `/exhibition/product-detail/custom`,
    method: 'post',
    data,
  })
}
// 获取钻石金重
export function getWeight(data) {
  return request({
    url: `/exhibition/product-custom-attribute/weight`,
    method: 'post',
    data,
  })
}

// 获取钻石价格范围
export function getPriceRange(data) {
  return request({
    url: `/exhibition/product-custom-attribute/price`,
    method: 'post',
    data,
  })
}

// 获取素金价格范围
export function getPlainPriceRange(data) {
  return request({
    url: `/exhibition/product-custom-attribute/plain/price`,
    method: 'post',
    data,
  })
}

// 收藏商品
export function addCollection(data) {
  return request({
    url: `/exhibition/collection/${data.id}?isLike=${data.isLike}`,
    method: 'PUT',
  })
}
// 感兴趣
export function interestedIn(data) {
  return request({
    url: `/exhibition/product-like/${data.id}?isLike=${data.isLike}`,
    method: 'PUT',
  })
}

// 感兴趣数量
export function interestCut(data) {
  return request({
    url: `/exhibition/product-like/like/count/${data}`,
    method: 'get',
    params: {},
  })
}

// 相似推薦
export function getRecommendation(styleNumber) {
  return request({
    url: `/exhibition/product/recommendPage/${styleNumber}`,
    method: 'get',
    params: {},
  })
}

// 进详情页获取数据
export function getDatailList(data) {
  return request({
    url: `/exhibition/cloudhall/goods/info?styleNumber=${data}`,
    method: 'get',
    params: {},
  })
}

// 获取可选属性跟金重
export function dynamicAttr(data) {
  return request({
    url: '/exhibition/cloudhall/goods/optionalAttr',
    method: 'post',
    data,
  })
}
// 钻石价格区间及库存
export function getPriceInventory(data) {
  return request({
    url: '/exhibition/cloudhall/goods/storeAndPrice',
    method: 'post',
    data,
  })
}
// 素金价格区间与库存
export function getGoldPriceInventory(data) {
  return request({
    url: '/exhibition/cloudhall/goods/GoldStoreAndPrice',
    method: 'post',
    data,
  })
}
// 现货列表
export function getSpotPaging(data) {
  return request({
    url:
      '/exhibition/cloudhall/goods/store?pageSize=' +
      data.pageSize +
      '&pageNum=' +
      data.pageNum,
    method: 'post',
    data,
  })
}
// 情侣款加入购物车
export function loversAddCart(data) {
  return request({
    url: '/exhibition/shoppingCart/addListCart',
    method: 'post',
    data,
  })
}

// 获取详情页各供应商库存
export function getDetailSupplier(data) {
  return request({
    url: `/exhibition/product-detail/supplier`,
    method: 'POST',
    data,
  })
}

// 获取详情页各规格库存
export function getDetailQuantity(data) {
  return request({
    url: `/exhibition/product-detail/stockQuantity`,
    method: 'POST',
    data,
  })
}

export function getPackage(data) {
  return request({
    url: `/exhibition/product-detail/packageInquiry`,
    method: 'GET',
    params: data,
  })
}
